module.exports = __webpack_public_path__ + "img/badge.cd834832.svg";